import type { TyreLayoutSubjectKind } from '@chukua/common';
import { referenceDataTabPath, type ReferenceDataTab } from '../../reference-data.paths';

/** A truck class's or trailer type's page lives under its catalogue tab, so the breadcrumbs lead back there and the sidebar keeps Reference data lit. */
export const VEHICLE_CLASS_TABS: Record<TyreLayoutSubjectKind, ReferenceDataTab> = {
  truck_class: 'truck-classes',
  trailer_type: 'trailer-types',
};

/** The segment a new row's page uses in place of a code. */
export const NEW_VEHICLE_CLASS = 'new';

export function vehicleClassPath(kind: TyreLayoutSubjectKind, code: string): string {
  return `${referenceDataTabPath(VEHICLE_CLASS_TABS[kind])}/${encodeURIComponent(code)}`;
}

export function newVehicleClassPath(kind: TyreLayoutSubjectKind): string {
  return `${referenceDataTabPath(VEHICLE_CLASS_TABS[kind])}/${NEW_VEHICLE_CLASS}`;
}

export function vehicleClassRoutePattern(kind: TyreLayoutSubjectKind, suffix = ''): string {
  return `reference-data/${VEHICLE_CLASS_TABS[kind]}/:code${suffix}`;
}
